export default __webpack_public_path__ + "static/media/Your inputs - Icon.3d65ddfa.svg";